module.exports = __webpack_public_path__ + "media/img/specialize/mobile/item4-555bd8e275b091f215e24c38ec91cef2.svg";